export const formatCurrency = (amount: number | string | null | undefined, minimumFractionDigits = 0) => {
  if (amount === null || amount === undefined) {
    return ''
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
  }).format(Number(amount))
}
